import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { checkAuthentication, handleAuthFailure } from '../utils/authCheck';

/**
 * ProtectedRoute component that validates user authentication with backend
 * on every page load/refresh. Redirects to login if session is invalid.
 */
const ProtectedRoute = ({ children }) => {
    const [authState, setAuthState] = useState({
        isChecking: true,
        isAuthenticated: false
    });
    
    useEffect(() => {
        const validateAuth = async () => {
            console.log('[ProtectedRoute] Validating authentication on page load...');
            console.log('[ProtectedRoute] Path:', window.location.pathname);
            
            // Quick check: if no currentUser in localStorage, skip API call
            const currentUser = localStorage.getItem('currentUser');
            if (!currentUser) {
                console.log('[ProtectedRoute] No user data in localStorage - not authenticated');
                setAuthState({ isChecking: false, isAuthenticated: false });
                return;
            }
            
            // Validate with backend API
            const isValid = await checkAuthentication();
            
            console.log('[ProtectedRoute] Backend validation result:', isValid);
            
            if (!isValid) {
                console.log('[ProtectedRoute] Session invalid - clearing data and redirecting to login');
                handleAuthFailure();
                // Note: handleAuthFailure will redirect, but we'll also set state for consistency
                setAuthState({ isChecking: false, isAuthenticated: false });
            } else {
                console.log('[ProtectedRoute] Session valid - rendering protected content');
                setAuthState({ isChecking: false, isAuthenticated: true });
            }
        };
        
        validateAuth();
    }, []); // Run once on mount (page load/refresh)
    
    // Show loading state while checking authentication
    if (authState.isChecking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
                <div className="text-center">
                    <div className="mb-4">
                        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Validating session...</h2>
                    <p className="text-gray-600">Please wait</p>
                </div>
            </div>
        );
    }
    
    // If not authenticated after check, redirect to login
    if (!authState.isAuthenticated) {
        console.log('[ProtectedRoute] Redirecting to login - authentication failed');
        return <Navigate to="/login" replace />;
    }

    // User is authenticated, render the protected component
    console.log('[ProtectedRoute] Rendering protected content');
    return children;
};

export default ProtectedRoute;

